import React from "react";

const logline = <p>This is a Christmas drama about a recently separated over-worked lawyer whose widowed father disappears at sea just before Christmas. Brad Wilson returns home to deal with his estranged family, a mountain of debt and his black sheep sister who inherits the majority of stock in their generational business that sells Christmas lights.</p>;

export default logline;